<template>
  <div class="customer-treatment-item" :class="{ done: is_done && is_paid }" :style="treatment_style">
    <div v-if="is_selectable" class="treatment-selected-icon">
      <div class="form-check form-check-inline">
        <input v-if="is_selectable" @change="toggleSelected" class="form-check-input" type="checkbox" :id="checkbox_id"
          :checked="selected" />
        <label class="form-check-label" :for="checkbox_id"></label>
      </div>
    </div>

    <div @click="toggleEdit" class="treatment-body mb-1">
      <span class="treatment-name">
        <span v-if="clinic_type == 'dental'">( {{ treatment_teeth }} ) -</span>
        {{ treatment.product ? treatment.full_name : "" }}

        <span v-if="treatment.max_sessions">
          ( {{ treatment.sessions_done }} de {{ treatment.max_sessions }} Sesiones )
        </span>

        <span v-if="!is_done && treatment.product.enable_stock">
          <strong v-if="treatment.product.stock <= 0"> - Agotado</strong>
          <span v-else> - Quedan {{ treatment.product.stock }} uds.</span>
        </span>

        <small class="treatment-variants">
          <span class="treatment-variant" v-for="variant, index in treatment_variants" :key="index">
            {{ variant.attr }}:{{ variant.value }}
          </span>
        </small>
      </span>

      <div class="treatment-is-done ml-4" :class="{ done: is_done }">
        <span v-if="is_done">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clip-path="url(#clip0_212_2094)">
              <path
                d="M6.31414 13.8661C6.17617 14.0038 5.98919 14.0811 5.79425 14.0811C5.59931 14.0811 5.41233 14.0038 5.27437 13.8661L1.12323 9.71389C1.02078 9.61153 0.939505 9.48997 0.884055 9.35618C0.828604 9.22239 0.800064 9.07898 0.800064 8.93415C0.800064 8.78932 0.828604 8.64592 0.884055 8.51212C0.939505 8.37833 1.02078 8.25678 1.12323 8.15441L1.64294 7.63643C1.74531 7.53398 1.86686 7.4527 2.00065 7.39725C2.13445 7.3418 2.27785 7.31326 2.42268 7.31326C2.56751 7.31326 2.71092 7.3418 2.84471 7.39725C2.9785 7.4527 3.10006 7.53398 3.20242 7.63643L5.79408 10.2264L12.7976 3.22319C12.9 3.12074 13.0215 3.03947 13.1553 2.98402C13.2891 2.92857 13.4325 2.90003 13.5773 2.90003C13.7222 2.90003 13.8656 2.92857 13.9994 2.98402C14.1332 3.03947 14.2547 3.12074 14.3571 3.22319L14.8768 3.7429C14.9792 3.84527 15.0605 3.96682 15.116 4.10062C15.1714 4.23441 15.2 4.37782 15.2 4.52264C15.2 4.66747 15.1714 4.81088 15.116 4.94467C15.0605 5.07846 14.9792 5.20002 14.8768 5.30238L6.31414 13.8661Z"
                fill="#6ECA98" />
            </g>
            <defs>
              <clipPath id="clip0_212_2094">
                <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
              </clipPath>
            </defs>
          </svg>
          Realizado {{ done_date }}
        </span>
        <span v-else>
          Sin Realizar
        </span>
      </div>

      <div class="treatment-is-done" :class="{ done: is_paid }">
        <span v-if="is_paid">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <path
              d="M1.76001 10.452L1.76001 8.88399L10.4 8.88399L10.4 10.452L1.76001 10.452ZM1.76001 8.24399L1.76001 6.67599L10.4 6.67599L10.4 8.24399L1.76001 8.24399ZM9.40801 14.388C8.52268 14.388 7.70134 14.2493 6.94401 13.972C6.19734 13.684 5.54668 13.2787 4.99201 12.756C4.44801 12.2333 4.02134 11.62 3.71201 10.916C3.40268 10.2013 3.24801 9.41732 3.24801 8.56399C3.24801 7.71066 3.40268 6.93199 3.71201 6.22799C4.02134 5.51332 4.44801 4.89466 4.99201 4.37199C5.54668 3.84932 6.19734 3.44932 6.94401 3.17199C7.70134 2.88399 8.52268 2.73999 9.40801 2.73999C10.4427 2.73999 11.3653 2.92132 12.176 3.28399C12.9973 3.64666 13.68 4.16933 14.224 4.85199L12.208 6.67599C11.856 6.24932 11.4613 5.92399 11.024 5.69999C10.5867 5.47599 10.1013 5.36399 9.56801 5.36399C9.10934 5.36399 8.68801 5.43866 8.30401 5.58799C7.93068 5.73732 7.60534 5.95599 7.32801 6.24399C7.05068 6.52132 6.83201 6.85732 6.67201 7.25199C6.52268 7.64666 6.44801 8.08399 6.44801 8.56399C6.44801 9.04399 6.52268 9.48132 6.67201 9.87599C6.83201 10.2707 7.05068 10.612 7.32801 10.9C7.60534 11.1773 7.93068 11.3907 8.30401 11.54C8.68801 11.6893 9.10934 11.764 9.56801 11.764C10.1013 11.764 10.5867 11.652 11.024 11.428C11.4613 11.204 11.856 10.8787 12.208 10.452L14.224 12.276C13.68 12.948 12.9973 13.4707 12.176 13.844C11.3653 14.2067 10.4427 14.388 9.40801 14.388Z"
              fill="#42B577" />
          </svg>
          Pagado {{ paid_date }}
        </span>
        <span v-else>
          Sin Pagar

          <span style="color:var(--theme-text-color)" v-if="treatment.paid_amount > 0">
            - Asig: <em>{{ paid_amount }}</em> - Pendiente: <em>{{ remaining_amount }}</em>
          </span>
        </span>
      </div>

    </div>

    <div v-if="total" class="treatment-total mx-3">
      {{ pretty_total }}
    </div>

    <div v-if="show_done" @click="markDone" data-toggle="tooltip" data-placement="top" title="Completar Tratamiento"
      class="treatment-done-icon" :class="{ done: is_done, doneprior: is_done_prior }">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill-rule="evenodd"
          d="M22.707 3.293a1 1 0 0 1 0 1.414l-10 10a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L12 12.586l9.293-9.293a1 1 0 0 1 1.414 0z"
          clip-rule="evenodd" />
        <path fill-rule="evenodd"
          d="M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7a1 1 0 1 1 2 0v7a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h11a1 1 0 1 1 0 2H5z"
          clip-rule="evenodd" />
      </svg>
    </div>
    <div v-if="!enable_payments_v2" @click="markPaid" class="treatment-paid-icon" data-toggle="tooltip"
      data-placement="top" title="Pagar Tratamiento" :class="{ paid: is_paid, notpaid: is_not_paid }">
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="20" viewBox="0 0 17 20">
        <path
          d="M15.9 16.4c-.3-.5-.9-.6-1.4-.4-3.4 2-8 .7-9.8-3.1H9c.6 0 1-.4 1-1s-.4-1-1-1H4.1C4 10.3 4 9.7 4.1 9H9c.6 0 1-.4 1-1s-.4-1-1-1H4.7c1.8-3.8 6.4-5.1 9.8-3.1.5.3 1.1.1 1.4-.4.3-.5.1-1.1-.4-1.4C10.7-.6 4.4 1.6 2.5 7H1c-.6 0-1 .4-1 1s.4 1 1 1h1.1c-.1.7-.1 1.3 0 2H1c-.6 0-1 .4-1 1s.4 1 1 1h1.5c1.9 5.4 8.2 7.6 13 4.8.5-.3.6-.9.4-1.4z" />
      </svg>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    clinic_type: { required: true },
    treatment: { required: true },
    clinics: { required: true },
    selected: { default: false },
    total: { default: 0 },
    show_done: { default: true },
    selectable: { default: false }
  },
  computed: {
    treatment_variants() {
      let ret = [];

      for (let id in this.treatment.variants) {
        for (let attr in this.treatment.variants[id]) {
          ret.push({
            attr: attr,
            value: this.treatment.variants[id][attr]
          });
        }
      }

      return ret;
    },
    treatment_notes() {
      let lines = [];
      if (this.treatment.quotation_id) {
        if (this.is_core) {
          lines.push("Planificado");
        } else {
          lines.push("Presupuestado");
        }
        if (this.treatment.is_approved) {
          lines.push("Aprobado");
        }
      } else {
        lines.push('Pendiente');
      }

      if (this.treatment.notes && this.treatment.notes != '') {
        lines.push(this.treatment.notes);
      }

      if (this.treatment.done_at && this.treatment.status == 'done') {
        let d = moment(this.treatment.done_at);
        lines.push('Realizado: ' + d.format('DD/MM/YY'));
      };

      if (this.treatment.paid_at && this.treatment.is_paid) {
        let d = moment(this.treatment.paid_at);
        lines.push('Pagado: ' + d.format('DD/MM/YY'));
      };

      return lines.join(" - ");
    },
    product_icon() {
      if (this.treatment.product) {
        return this.treatment.product.icon;
      }

      return null;
    },
    clinic_name() {
      let name = this.clinics[this.treatment.clinic_id] || null;
      return name ? name : "";
    },
    pretty_total() {
      return WabiDent.fmtMoney(this.total);
    },
    treatments_show_done_date() {
      return false;
    },
    treatment_date() {
      let dates = [
        moment(this.treatment.created_at).toDate().toLocaleDateString()
      ];
      let done_at = this.treatment.done_at;
      let paid_at = this.treatment.paid_at;

      if (this.treatments_show_done_date && this.treatment.status == 'done' && done_at) {
        dates.push('Realz: ' + moment(done_at).toDate().toLocaleDateString());
      }

      return dates.join(' - ');
    },
    treatment_teeth() {
      if (!this.treatment || !this.treatment.teeth) {
        return '';
      }

      return this.treatment.teeth.reduce((accum, value) => {
        return accum + ` ${value}`;
      }, "");
    },
    checkbox_id() {
      return `treatment_check_${this.treatment.id}`;
    },
    is_done_prior() {
      return this.treatment.status == "done_prior";
    },
    is_quoted() {
      return Boolean(this.treatment.quotation_id);
    },
    is_not_paid() {
      return !this.is_paid;
    },
    is_selectable() {
      return this.selectable || !(this.is_quoted || this.is_done_prior);
    },
    treatment_style() {
      let ret = {};

      if (this.treatment && this.treatment.color) {
        ret["background-color"] = window.WabiDent.hexToRGBA(
          this.treatment.color,
          0.125
        );
      }
      return ret;
    },
    paid_amount() {
      return WabiDent.fmtMoney(this.treatment.paid_amount);
    },
    remaining_amount() {
      return WabiDent.fmtMoney(this.total - this.treatment.paid_amount);
    },
    is_paid() {
      return this.treatment && this.treatment.is_paid && this.treatment.paid_at;
    },
    is_done() {
      return this.treatment && (this.treatment.status == 'done' || this.treatment.status == 'done_prior') && this.treatment.done_at;
    },
    done_date() {
      return window.WabiDent.fmtDate(this.treatment.done_at);
    },
    paid_date() {
      return window.WabiDent.fmtDate(this.treatment.paid_at);
    },
    enable_payments_v2() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_payments_v2;
    },
    ...mapGetters(['clinic', 'is_core'])
  },
  methods: {
    getIconColor(treatment) {
      return WabiDent.getIconColor(treatment);
    },
    toggleSelected(ev) {
      this.$emit("select", this.treatment, ev.target.checked);
    },
    toggleEdit() {
      this.$emit("edit", this.treatment);
    },
    markDone() {
      this.$emit("done", this.treatment);
    },
    markPaid() {
      this.$emit("paid", this.treatment);
    },
  },
};
</script>

<style lang="scss">
.customer-treatment-item {
  cursor: pointer;
  padding: 15px 10px;
  border-radius: 5px;
  background: var(--ui-gris-medio, #F9F9F8);
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  .treatment-kind-icon,
  .treatment-selected-icon,
  .treatment-done-icon,
  .treatment-paid-icon {
    flex: 0 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--theme-grey);

    svg {
      fill: currentColor;
    }

    .form-check {
      margin: 1px 0 0 0;
    }

    .wabident-treatment-icon {
      width: 20px;
      height: 20px;
      padding: 5px 0;
      font-size: 18px;
    }
  }

  .treatment-done-icon.done {
    color: var(--theme-color-attended);
  }

  .treatment-done-icon.doneprior {
    color: var(--theme-color-absent);
  }

  .treatment-paid-icon.paid {
    color: var(--theme-color-attended);
  }

  .treatment-paid-icon.notpaid {
    color: var(--theme-color-absent);
  }

  .treatment-body {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .treatment-date {
      color: var(--theme-line-color);
      font-size: 14px;
      font-weight: 500;
      vertical-align: middle;

      strong {
        font-weight: 700;
        color: var(--theme-text-color);
      }
    }

    .treatment-name {
      color: var(--theme-text-color);
      vertical-align: middle;
      font-size: 16px;
      font-weight: normal;
    }

    .treatment-notes {
      font-size: 12px;
      color: var(--theme-grey);
      font-weight: 500;
    }
  }

  .treatment-total {
    font-size: 18px;
    color: var(--theme-color-attended);
    letter-spacing: 0.36px;
    flex: 0 0 120px;
    text-align: right;
  }

  .treatment-variant {
    font-weight: 500;
    font-size: 0.9em;
  }

  .treatment-variant::before {
    content: '|';
    margin: 5px;
    display: inline-block;
  }

  .treatment-status {
    cursor: pointer;
    border-radius: 20px;
    background: var(--ui-gris-oscuro, #EDEFF2);
    padding: 4px 10px;
    color: var(--texto-gris, #A6AAB4);
    font-size: 13px;
    font-weight: 700;
    transition: .2s ease;
    margin-left: 20px;

    &.approved {
      background: var(--texto-azul-planificado, #72B4E4);
      color: white;
    }
  }

  .treatment-doctors {
    color: var(--theme-text-color);
    font-size: 12px;
    font-weight: 700;
    position: relative;
    padding-left: 10px;
    margin-left: 5px;

    &::before {
      width: 2px;
      height: 15px;
      vertical-align: middle;
      margin: 0 10px;
      background: var(--texto-gris, #A6AAB4);
      content: '';
      left: -10px;
      top: 50%;
      transform: translateY(-50%);
      display: inline-block;
      position: absolute;
    }
  }

  .treatment-is-done {
    color: var(--texto-gris, #A6AAB4);
    font-size: 13px;
    font-weight: 700;
    margin: 5px;

    &.done {
      color: #42B577;
    }
  }

}
</style>
